import { LocationPin } from "../../icons/location-pin";
import { Search } from "../../icons/search";
import { FormField, ParentFormField } from "./edit-userdata.types";

export const userFormFields: FormField[] = [
  {
    key: "name",
    label: "Nama",
    type: "text",
    hintText: "Pakai nama asli soalnya nanti nggak bisa diganti lagi."
  },
  {
    key: "email",
    label: "Email",
    type: "email"
  },
  {
    key: "residence",
    label: "Tempat tinggal",
    type: "suggestion",
    hasIcon: true,
    icon: <LocationPin width={20} height={20} color="#8C9CB6" />
  },
  {
    key: "schoolName",
    label: "Nama sekolah",
    type: "suggestion",
    hasIcon: true,
    icon: <Search width={20} height={20} color="#8C9CB6" />
  },
  {
    key: "grade",
    label: "Kelas",
    type: "text",
    disabled: true
  },
  {
    key: "curriculum",
    label: "Kurikulum",
    type: "text",
    disabled: true
  }
];

export const parentFormFields: ParentFormField[] = [
  {
    key: "parentPhone",
    label: "Nomor HP orangtua",
    type: "tel"
  },
  {
    key: "parentName",
    label: "Nama orangtua",
    type: "text"
  }
];

// Default data
export const defaultUserData = {
  name: "Putri Amalia Ramdhani",
  email: "putriamalia@gmail.com",
  residence: "Tomohon",
  schoolName: "SMP Negeri 1 Tomohon",
  grade: "SMP -Kelas 8",
  curriculum: "Kurikkulum Merdeka"
};

export const defaultParentData = {
  parentName: "Saratudin Ahmad",
  parentPhone: "081234567890"
};
